import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material';

import {AuthService} from '../../services/auth.service';
import {UserService} from '../../services/user.service';

import {TemperatureUnit} from '../../../shared/index';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'awair-p13n-dialog',
  templateUrl: './p13n-dialog.component.html',
  styleUrls: ['./p13n-dialog.component.scss']
})

export class P13nDialogComponent implements OnInit {

  TemperatureUnit = TemperatureUnit;

  temperatureUnit: TemperatureUnit;
  organizationToken: string;

  private initialTemperatureUnit: TemperatureUnit;

  constructor(private authService: AuthService,
              private userService: UserService,
              private route: ActivatedRoute,
              private myDialogRef: MatDialogRef<P13nDialogComponent>) {
  }

  ngOnInit() {
    this.initialTemperatureUnit = this.temperatureUnit;
  }

  onSave(): void {
    // Check if setting has changed
    if (this.initialTemperatureUnit === this.temperatureUnit) {
      this.onClose(false);
    } else {
      this.userService.changeTempUnit(this.organizationToken, this.temperatureUnit).subscribe(
        (response: { message: string }) => {
          this.onClose(true);
        },
        (error: HttpErrorResponse) => {
          alert('Failed to change settings.\nPlease try again later');
          this.onClose(false);
        }
      );
    }
  }

  onClose(isSettingChanged: boolean): void {
    this.myDialogRef.close({'isSettingChanged': isSettingChanged || false});
  }
}
